import { StyleSheet } from 'react-native';

import { COLOR, blackTransparent, lightGrey } from 'utils/colors';

const styles = StyleSheet.create({
    root: {
        flex: 1,
        borderRightWidth: 2,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        borderRadius: 2,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
    },
    selected: {
        ...StyleSheet.absoluteFillObject,
        borderRadius: 2,
        backgroundColor: lightGrey(0.2),
    },
    numberBlock: {
        width: 44,
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    logoBlock: {
        width: 76,
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    logo: {
        height: 32,
        width: 76,
    },
    unsubscribedOverlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: blackTransparent(0.5),
    },
    channelName: {
        textAlign: 'center',
    },
});

export default styles;
